import React, {Component} from "react"

import Head from "shared/components/head"
import Context from "shared/context"

import App from "components/app"
import Hero from "components/hero"
import Content from "components/content"
import Header from "components/header"
import Footer from "components/footer"

import Image from "shared/assets/images/sharing.jpg"

export default class Home extends Component {
  constructor(data) {
    super(data)
    this.state = {
      isOpen: false
    }  
  }

  toggleMenu() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render() {
    return (
      <App>
        <Head title="CITIZEN LONG" description="FOOD. EVENTS. SPACE - Am Fruchtkasten 3 - 70173 Stuttgart" image={Image} />
        <Context.Provider value={{ menu: this.state.isOpen, theme: 'dark' }}>
          <Header toggleContentHandler={() => { this.toggleMenu() }} />
          <Hero toggleContentHandler={() => { this.toggleMenu() }} />
          <Content />
          <Footer />
        </Context.Provider>
      </App>
    )
  }
}